import { styled } from '@linaria/react';
import { colors, semantic, space } from '../../theme/tokens';

export const ToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-100']};
  padding: ${space['space-100']};
  border-radius: 9999px;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ToggleButton = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 9999px;
  background: ${({ $active }) => ($active ? semantic.bg.canvas : 'transparent')};
  color: ${({ $active }) => ($active ? semantic.text.primary : semantic.text.secondary)};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    color: ${semantic.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;
